import { Link, useRouterState } from '@tanstack/react-router';
import { useCart } from '../lib/cart-store.js';
import { IconCart, IconClients, IconHome, IconOrders, IconSearch, IconUser } from './icons.js';

const TABS = [
  { to: '/', label: 'Home', Icon: IconHome, match: '/' },
  { to: '/clients', label: 'Clients', Icon: IconClients, match: '/clients' },
  { to: '/inventory', label: 'Inventory', Icon: IconSearch, match: '/inventory' },
  { to: '/orders', label: 'Orders', Icon: IconOrders, match: '/orders' },
  { to: '/cart', label: 'Cart', Icon: IconCart, match: '/cart' },
  { to: '/me', label: 'Me', Icon: IconUser, match: '/me' },
] as const;

export function TabBar() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  const cartCount = useCart((s) => s.items.length);

  return (
    <nav className="tabbar">
      {TABS.map(({ to, label, Icon, match }) => {
        const active =
          match === '/' ? path === '/' : path === match || path.startsWith(`${match}/`);
        return (
          <Link key={to} to={to} className={`tab${active ? ' active' : ''}`}>
            <Icon />
            {label}
            {to === '/cart' && cartCount > 0 && <span className="tab-badge">{cartCount}</span>}
          </Link>
        );
      })}
    </nav>
  );
}
